import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import Location from './Filter/Location';
import Budget from './Filter/Budget';
import Type from './Filter/Type';
import Room from './Filter/Room';
import Surface from './Filter/Surface';
import MoreCriteria from './Filter/MoreCriteria';
import MobileTab from './components/MobileTab';

import { buyerAlertUrl } from '../../utils/buyerAlertUrl'

import { setSelectedTab, updateBaseFilters } from '../../reducers/filtersSlice';

const Filters = () => {
  const { collection: filtersCollection, hasUnsavedFilters } = useSelector((state) => state.filters)
  const { desktopDevice } = useSelector((state) => state.viewportSlice);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const filtersRef = useRef(null)
  const { baseCollection: filters, filtersChanged } = useSelector((state) => state.filters);

  useEffect(() => {
    searchParams.set('zones', JSON.stringify(filtersCollection.zones))
    searchParams.set('apartment', filtersCollection.type.apartment)
    searchParams.set('house', filtersCollection.type.house)
    searchParams.set('min_budget', filtersCollection.budget.min_budget)
    searchParams.set('max_budget', filtersCollection.budget.max_budget)
    searchParams.set('min_area', filtersCollection.surface.min_area)
    searchParams.set('max_area', filtersCollection.surface.max_area)
    searchParams.set('min_room_number', filtersCollection.room?.min_room_number)
    searchParams.set('min_bedroom_number', filtersCollection.room?.min_bedroom_number)
    searchParams.set('more_criteria', filtersCollection.more_criteria.map(criteria => criteria).join(','))
    searchParams.set('dpe', filtersCollection.dpe.map(criteria => criteria).join(','))

    setSearchParams(searchParams)
  }, [filtersCollection]);

  useEffect(() => {
    document.addEventListener('click', (event) => {
      const filtersElement = filtersRef.current
      const dropdownElement = document.getElementById('dropdown-container')
      const clickedElement = event.target;

      if (!dropdownElement?.contains(clickedElement) && hasUnsavedFilters) dispatch(updateBaseFilters());

      if (!filtersElement?.contains(clickedElement)) dispatch(setSelectedTab(null));
    });
  }, [hasUnsavedFilters]);

  return(
    <>
      {desktopDevice &&
        <div className='vesta-bg-purple-10 vesta-padding-y-30 vesta-sticky-container vesta-w-full'>
          <div className='vesta-flex-row-center vesta-gap-10'>
            <div className='vesta-filters-container' ref={filtersRef}>
              <Location />
              <Type />
              <Budget />
              <Room />
              <Surface />
              <MoreCriteria />
            </div>

            <a href={buyerAlertUrl(filters)} target='_blank' rel='noreferrer nofollow' className='vesta-button--primary vesta-button--icon-left'>
              <i className='fa fa-bell vesta-button--icon-left'></i>
              <span className='typo-h4'>{filtersChanged ? 'Enregistrer ma recherche' : 'Créer une alerte achat'}</span>
            </a>
          </div>
        </div>
      }

      {!desktopDevice && (
        <div className='vesta-bg-purple-10 vesta-padding-y-20 vesta-sticky-container'>
          <div className='vesta-filters-container vesta-w-full vesta-flex-row-center' ref={filtersRef}>
            <Location />

            <MobileTab tab='mobileFilters' />
          </div>
        </div>
      )}
    </>
  )
};

export default Filters;
